export const InvoiceKindLabelMapping = {
  not_target: '対象外',
  qualified: '適格',
  unqualified_eighty: '80%控除',
  unqualified_seventy: '70%控除',
  // unqualified_fifty: '50%控除',
  unqualified: '非適格',
};
